import React from 'react';

function Units() {
  return (
    <section id="unidades" className="container my-5">
        <br />
        
      <h2 className="text-center mb-4">Unidades</h2>
      <br />
      
      <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4">
        {/* Unidade: Visão Positiva Caicó */}
        <div className="col">
          <div
            className="card h-100 border-0 shadow"
            style={{ backgroundColor: '#ea2325', color: '#fff', fontWeight: 'bold' }}
          >
            <div className="card-body">
              <h5 className="card-title">Visão Positiva Caicó</h5>
              <p className="card-text">
                Av. Cel. Martiniano, 2870C - Vila Altiva, Caicó - RN, 59300-000<br />
                <i className="bi bi-telephone-fill me-1"></i> (84) 4106-0166<br />
                <i className="bi bi-envelope-fill me-1"></i> visaopositivacaico@gmail.com
              </p>
            </div>
          </div>
        </div>

        {/* Unidade: Visão Positiva Currais Novos */}
        <div className="col">
          <div
            className="card h-100 border-0 shadow"
            style={{ backgroundColor: '#01295c', color: '#fff', fontWeight: 'bold' }}
          >
            <div className="card-body">
              <h5 className="card-title">Visão Positiva Currais Novos</h5>
              <p className="card-text">
                R. Raul Dantas de Medeiros, 323 - JK, Currais Novos - RN, 59380-000<br />
                <i className="bi bi-telephone-fill me-1"></i> (84) 84 9870-1006<br />
                <i className="bi bi-envelope-fill me-1"></i> visaopositivacn@gmail.com
              </p>
            </div>
          </div>
        </div>

        {/* Unidade: Visão Positiva Mossoró */}
        <div className="col">
          <div
            className="card h-100 border-0 shadow"
            style={{ backgroundColor: '#01429b', color: '#fff', fontWeight: 'bold' }}
          >
            <div className="card-body">
              <h5 className="card-title">Visão Positiva Mossoró</h5>
              <p className="card-text">
                R. José Damião, 304 - Abolição II, Mossoró - RN, 59619-140<br />
                <i className="bi bi-telephone-fill me-1"></i> (84) 4109-0001<br />
                <i className="bi bi-envelope-fill me-1"></i> visaopositivamossoro@gmail.com
              </p>
            </div>
          </div>
        </div>

        {/* Unidade: Visão Positiva Natal */}
        <div className="col">
          <div
            className="card h-100 border-0 shadow"
            style={{ backgroundColor: '#ea2325', color: '#fff', fontWeight: 'bold' }}
          >
            <div className="card-body">
              <h5 className="card-title">Visão Positiva Natal</h5>
              <p className="card-text">
                Av. Interventor Mário Câmara - Alecrim, Natal - RN, 59032-600<br />
                <i className="bi bi-telephone-fill me-1"></i> (84) 4141-4755<br />
                <i className="bi bi-envelope-fill me-1"></i> visaopositivanatal@gmail.com
              </p>
            </div>
          </div>
        </div>

        {/* Unidade: Visão Positiva Nova Cruz */}
        <div className="col">
          <div
            className="card h-100 border-0 shadow"
            style={{ backgroundColor: '#01295c', color: '#fff', fontWeight: 'bold' }}
          >
            <div className="card-body">
              <h5 className="card-title">Visão Positiva Nova Cruz</h5>
              <p className="card-text">
                Rua Frei Serafim de Catânea, 891, Nova Cruz - RN, 59215-000<br />
                <i className="bi bi-telephone-fill me-1"></i> (84) 9841-1005<br />
                <i className="bi bi-envelope-fill me-1"></i> visaopositivancz@gmail.com
              </p>
            </div>
          </div>
        </div>

        {/* Unidade: Visão Positiva Parnamirim */}
        <div className="col">
          <div
            className="card h-100 border-0 shadow"
            style={{ backgroundColor: '#01429b', color: '#fff', fontWeight: 'bold' }}
          >
            <div className="card-body">
              <h5 className="card-title">Visão Positiva Parnamirim</h5>
              <p className="card-text">
                R. Rio Nilo, 121 - Emaús, Parnamirim - RN, 59149-130<br />
                <i className="bi bi-telephone-fill me-1"></i> (84) 4103-1001<br />
                <i className="bi bi-envelope-fill me-1"></i> visaopositivaparnamirim@gmail.com
              </p>
            </div>
          </div>
        </div>

        {/* Unidade: Visão Positiva Pau dos Ferros */}
        <div className="col">
          <div
            className="card h-100 border-0 shadow"
            style={{ backgroundColor: '#ea2325', color: '#fff', fontWeight: 'bold' }}
          >
            <div className="card-body">
              <h5 className="card-title">Visão Positiva Pau dos Ferros</h5>
              <p className="card-text">
                R. São Benedito, 141 - Centro, Pau dos Ferros - RN, 59900-000<br />
                <i className="bi bi-telephone-fill me-1"></i> (84) 9619-1001<br />
                <i className="bi bi-envelope-fill me-1"></i> visaopositivapdf@gmail.com
              </p>
            </div>
          </div>
        </div>

        {/* Unidade: Visão Positiva Santa Cruz */}
        <div className="col">
          <div
            className="card h-100 border-0 shadow"
            style={{ backgroundColor: '#01295c', color: '#fff', fontWeight: 'bold' }}
          >
            <div className="card-body">
              <h5 className="card-title">Visão Positiva Santa Cruz</h5>
              <p className="card-text">
                Av. Trairi, 94C - Três a um, Santa Cruz - RN, 59200-000<br />
                <i className="bi bi-telephone-fill me-1"></i> (84) 9840-1003<br />
                <i className="bi bi-envelope-fill me-1"></i> visaopositivastc@gmail.com
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Units;
